import {Component} from '@angular/core';
import {TableControlComponent, TableControlModule} from 'frontier/browserkit';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-collectiveinvoice-table',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
})
export class CollectiveinvoiceTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TCollectiveInvoiceTable;
}
